import PropTypes from 'prop-types';

const Grid = ({ time, grid }) => {
  return (
    <div>
      {(grid ?? [])?.map(({ id, start, end, isLastDay }) => (
        <div
          key={id}
          className={`absolute bottom-0 top-0 bg-white ${
            isLastDay && 'border-r'
          } `}
          style={time?.toStyleLeftAndWidth?.(start, end)}
        />
      ))}
    </div>
  );
};

Grid.propTypes = {
  time: PropTypes.shape({
    toStyleLeftAndWidth: PropTypes.func,
  }).isRequired,
  grid: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.instanceOf(Date).isRequired,
      end: PropTypes.instanceOf(Date).isRequired,
    })
  ).isRequired,
};

export default Grid;
